/**
 * @generated SignedSource<<758031b20e43eb9ebac8832a9a2d8b8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsRouteQuery$variables = {};
export type SettingsRouteQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly account: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"SettingsGeneralTab_account" | "SettingsEmailTab_account">;
    };
  } | null;
};
export type SettingsRouteQuery = {
  variables: SettingsRouteQuery$variables;
  response: SettingsRouteQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketingAccount",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SettingsGeneralTab_account"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SettingsEmailTab_account"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SettingsRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketingAccount",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoCloseDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ticketNumberNext",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "responseSlaValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "responseSlaUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resolutionSlaValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resolutionSlaUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inboundLocalPart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inboundEmailDomain",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportEmailDomainConfigured",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AutoReplyConfig",
                "kind": "LinkedField",
                "name": "autoReply",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fromName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fromEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bodyHtml",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resolvedEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resolvedFromName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resolvedFromEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resolvedBodyHtml",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ad854505a95eefc49925e51d0fcf4f37",
    "id": null,
    "metadata": {},
    "name": "SettingsRouteQuery",
    "operationKind": "query",
    "text": "query SettingsRouteQuery {\n  viewer {\n    actualPersonId\n    account {\n      id\n      ...SettingsGeneralTab_account\n      ...SettingsEmailTab_account\n    }\n    id\n  }\n}\n\nfragment SettingsEmailTab_account on TicketingAccount {\n  id\n  inboundLocalPart\n  inboundEmailDomain\n  supportEmailDomainConfigured\n  autoReply {\n    enabled\n    fromName\n    fromEmail\n    bodyHtml\n    resolvedEnabled\n    resolvedFromName\n    resolvedFromEmail\n    resolvedBodyHtml\n  }\n}\n\nfragment SettingsGeneralTab_account on TicketingAccount {\n  id\n  autoCloseDays\n  slug\n  ticketNumberNext\n  responseSlaValue\n  responseSlaUnit\n  resolutionSlaValue\n  resolutionSlaUnit\n}\n"
  }
};
})();

(node as any).hash = "21f7aaa82018ac09d4e3d1e6f34d919f";

export default node;
